import { TableCell, TableRow } from '@mui/material';
import { calcItemRows, ItemResultTable } from '../ResultTable';
import { isEmptyData } from '../../../_utils/utils';
import { getColorByLabel } from '../../../_utils/inspectionUtils';
import { Depth1RowProps } from './Depth1Row';

type Depth2RowProps = Depth1RowProps & {
  detail: ItemResultTable;
  detailIndex: number;
};
/** 2層目までの小項目1行分 */
const Depth2Row: React.FC<Depth2RowProps> = ({
  category,
  type,
  item,
  problem,
  detail,
  typeIndex,
  itemIndex,
  problemIndex,
  detailIndex,
  tableStyle,
}) => {
  return (
    <TableRow>
      {typeIndex === 0 &&
        itemIndex === 0 &&
        problemIndex === 0 &&
        detailIndex === 0 && (
          <TableCell
            sx={tableStyle.category}
            rowSpan={category.typeResultList.reduce((rows, type) => {
              return rows + calcItemRows(type.itemResultList);
            }, 0)}
          >
            {category.label}
          </TableCell>
        )}
      {itemIndex === 0 && problemIndex === 0 && detailIndex === 0 && (
        <TableCell
          sx={tableStyle.type}
          rowSpan={calcItemRows(type.itemResultList)}
        >
          {type.label}
        </TableCell>
      )}
      {problemIndex === 0 && detailIndex === 0 && (
        <TableCell
          sx={{
            ...tableStyle.item,
            borderRight: problem.label === '' ? 'none' : tableStyle.item.border,
          }}
          rowSpan={calcItemRows(item.itemResultList)}
        >
          {item.label}
        </TableCell>
      )}
      {detailIndex === 0 && (
        <TableCell
          sx={{
            ...tableStyle.item,
            borderLeft: problem.label === '' ? 'none' : tableStyle.item.border,
          }}
          rowSpan={calcItemRows(problem.itemResultList)}
        >
          {problem.label}
        </TableCell>
      )}
      <TableCell sx={tableStyle.item}>{detail.label}</TableCell>
      <TableCell
        sx={{
          ...tableStyle.result,
          color: getColorByLabel(detail.inResult),
        }}
        colSpan={isEmptyData(item.inNumericalValue) ? 2 : 1}
      >
        {detail.inResult}
      </TableCell>
      {!isEmptyData(item.inNumericalValue) && detailIndex === 0 && (
        <TableCell
          sx={[tableStyle.result]}
          rowSpan={problem.itemResultList.length}
        >
          {item.inNumericalValue}
        </TableCell>
      )}
      <TableCell
        sx={{
          ...tableStyle.result,
          color: getColorByLabel(detail.qcResult),
        }}
        colSpan={isEmptyData(item.qcNumericalValue) ? 2 : 1}
      >
        {detail.qcResult}
      </TableCell>
      {!isEmptyData(item.qcNumericalValue) && detailIndex === 0 && (
        <TableCell
          sx={[tableStyle.result]}
          rowSpan={problem.itemResultList.length}
        >
          {item.qcNumericalValue}
        </TableCell>
      )}
    </TableRow>
  );
};

export default Depth2Row;
